import { createStandardAction } from "typesafe-actions";

import { BookRecurringOrder } from "./model/BookRecurringOrder";

export const updateOrder = createStandardAction("recurringBooking/UPDATE").map(
  (order: BookRecurringOrder) => ({
    payload: order
  })
);

export const resetOrder = createStandardAction("recurringBooking/RESET")();

// export const createOrderAsync = createAsyncAction(
//   "recurringBooking/CREATE_ORDER_REQUEST",
//   "recurringBooking/CREATE_ORDER_SUCCESS",
//   "recurringBooking/CREATE_ORDER_FAILURE",
// )<CreateOrderRequest, BookRecurringOrder, Error>();